export const MEDIA_CONTROL_BINDING_GESTURES = [
  'double_click',
  'triple_click',
  'quadruple_click',
  'long_press',
  'none',
] as const;

export type MediaControlBindingGesture = (typeof MEDIA_CONTROL_BINDING_GESTURES)[number];

/** @deprecated Use MediaControlBindingGesture */
export type MediaControlGesture = MediaControlBindingGesture;

export type MediaControlActionKey = 'media' | 'segment' | 'flow';

export interface MediaControlBindings {
  media: MediaControlBindingGesture;
  segment: MediaControlBindingGesture;
  flow: MediaControlBindingGesture;
}

export type MediaControlSettingsSource = 'default' | 'organization' | 'event' | 'flow';

export interface ResolvedMediaControlSettings {
  bindings: MediaControlBindings;
  source: MediaControlSettingsSource;
  allowEventOverride: boolean;
  allowFlowOverride: boolean;
  canEditAtEvent: boolean;
  canEditAtFlow: boolean;
  organization?: {
    bindings?: Partial<MediaControlBindings>;
    allowEventOverride?: boolean;
  };
  event?: {
    bindings?: Partial<MediaControlBindings>;
    allowFlowOverride?: boolean;
  };
  flow?: {
    bindings?: Partial<MediaControlBindings>;
  };
}
